// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ppfaDialog {
  width: 85rem;
}
.ppfaDialog .file-list-data-row:nth-child(1) {
  max-width: 200px;
}
.ppfaDialog .p-dialog-header {
  padding: 10px 18px !important;
}
.ppfaDialog .p-dialog-header1 {
  padding: 0 10px 9px !important;
}
.ppfaDialog .ppfaDialogBreadCrumb {
  padding-bottom: 12px !important;
}
.ppfaDialog .p-fileupload-content {
  top: 100% !important;
}
.ppfaDialog .p-fluid .p-fileupload .p-button {
  padding: 0;
}
.ppfaDialog .p-fileupload {
  padding: 0;
}
.ppfaDialog .p-fileupload .p-fileupload-row .upload-row {
  padding: 0;
  margin-top: 10px;
  text-align: left;
}
.ppfaDialog .p-fileupload-content {
  padding: 0 20px !important;
}

.ppfaDialogBorder {
  border: 1px solid #acacac;
  padding: 24px 24px 0 24px;
  border-radius: 4px;
}

.confirmPPFA {
  padding: 16px 0 1px 0 !important;
  text-align: right;
  display: flex;
  justify-content: space-between;
}
.confirmPPFA ul {
  list-style: none;
  text-align: left;
  padding: 0 0 0 5px;
}
.confirmPPFA .p-button {
  margin: 0 !important;
}

.confirmPPFA > button {
  background-color: #003da5 !important;
  width: 93px;
  height: 40px;
  color: #fff !important;
  font-size: 12px;
  border-radius: 20px;
  padding: 16px 24px;
}

.ppfaDialogTextColor {
  color: #ff0000;
  text-align: center;
}

.radioLabel {
  margin-left: 8px !important;
}

.cppfa-radio-buttons {
  display: flex;
}

.p-fileupload-content {
  padding: 0 1rem !important;
}

.highRiskData {
  border: 0.5px solid #acacac;
  min-width: 200px;
  border-radius: 8px;
  padding: 0;
  margin: 10.5px;
}

.highRiskDataPaddingBottom {
  padding-bottom: 24px;
}

.highRiskDataColor {
  color: #595959;
  font-weight: 400;
  font-size: 12px;
  line-height: 12.19px;
  padding: 10px;
  width: 18rem;
  margin-bottom: 10px;
}
.highRiskDataColor div {
  font-size: 10px;
}

.highRiskButtons {
  display: flex;
  justify-content: right;
  padding-top: 2px;
  margin-bottom: 10px;
}
.highRiskButtons .btn.btn-secondary {
  color: #595959 !important;
}
.highRiskButtons .highRiskButton {
  width: 33px;
  height: 20px;
  border: 0.5px solid #acacac !important;
  border-radius: 4px;
  margin-right: 10px;
  font-size: 10px;
  line-height: 12px;
}
.highRiskButtons .highRiskButton.btn:disabled {
  color: #ffffff !important;
  width: 33px;
  height: 20px;
  border: 0.5px solid #acacac !important;
  border-radius: 4px;
  margin-right: 10px;
  font-size: 10px;
  line-height: 12px;
}

.yesOrNoButtonsColor.btn:disabled {
  background-color: #003da5 !important;
}

.highRiskErrorBorderColor {
  border-color: #ff0000 !important;
}

.highRiskError {
  color: #ff0000;
  font-size: 8px;
  line-height: 10px;
  margin: 4px 0 10px 0;
}

.yesOrNoButtonsColor {
  background-color: #003da5;
  color: #ffffff !important;
}

.yesOrNoButtonsColor:hover {
  background-color: #003da5 !important;
  color: black !important;
}

.uploadIcon {
  background-color: #fff;
}

.fileSupportedData {
  font-size: 8px;
  line-height: 9.75px;
  color: #5b5959;
}

.uploadImage {
  cursor: pointer;
  width: 100%;
  text-align: center;
  margin-top: 10px;
}

.ppfaDialogLoading {
  padding-top: 100px;
}

.cpp-fa-button {
  display: flex;
  flex-direction: row-reverse;
  margin: 0px 8px;
}
.cpp-fa-button button {
  border-radius: 4px;
  padding: 4px 10px;
  margin: 3px;
}

.select-one {
  padding-top: 1rem;
}`, "",{"version":3,"sources":["webpack://./src/components/AWMJobs/CPPFA/index.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;AACF;AAEI;EACE,gBAAA;AAAN;AAKE;EACE,6BAAA;AAHJ;AAME;EACE,8BAAA;AAJJ;AAOE;EACE,+BAAA;AALJ;AAQE;EACE,oBAAA;AANJ;AASE;EACE,UAAA;AAPJ;AAUE;EACE,UAAA;AARJ;AAaM;EACE,UAAA;EACA,gBAAA;EACA,gBAAA;AAXR;AAgBE;EACE,0BAAA;AAdJ;;AAkBA;EACE,yBAAA;EACA,yBAAA;EACA,kBAAA;AAfF;;AAkBA;EACE,gCAAA;EACA,iBAAA;EACA,aAAA;EAEA,8BAAA;AAhBF;AAkBE;EACE,gBAAA;EAEA,gBAAA;EAEA,kBAAA;AAlBJ;AAoBE;EACE,oBAAA;AAlBJ;;AAsBA;EACE,oCAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;AAnBF;;AAsBA;EACE,cAAA;EACA,kBAAA;AAnBF;;AAsBA;EACE,2BAAA;AAnBF;;AAsBA;EACE,aAAA;AAnBF;;AAsBA;EACE,0BAAA;AAnBF;;AAsBA;EACE,2BAAA;EACA,gBAAA;EAEA,kBAAA;EACA,UAAA;EACA,cAAA;AApBF;;AAuBA;EACE,oBAAA;AApBF;;AAuBA;EACE,cAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;EACA,aAAA;EACA,YAAA;EACA,mBAAA;AApBF;AAqBE;EACE,eAAA;AAnBJ;;AAuBA;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,mBAAA;AApBF;AAqBE;EACE,yBAAA;AAnBJ;AAqBE;EAEE,WAAA;EACA,YAAA;EACA,sCAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;AApBJ;AAqBI;EACE,yBAAA;EACA,WAAA;EACA,YAAA;EACA,sCAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;AAnBN;;AAwBA;EACE,oCAAA;AArBF;;AAwBA;EACE,gCAAA;AArBF;;AAwBA;EACE,cAAA;EACA,cAAA;EACA,iBAAA;EACA,oBAAA;AArBF;;AAwBA;EACE,yBAAA;EACA,yBAAA;AArBF;;AAwBA;EACE,oCAAA;EACA,uBAAA;AArBF;;AAwBA;EACE,sBAAA;AArBF;;AAwBA;EACE,cAAA;EACA,mBAAA;EACA,cAAA;AArBF;;AAuBA;EACE,eAAA;EAEA,WAAA;EACA,kBAAA;EACA,gBAAA;AArBF;;AAwBA;EACE,kBAAA;AArBF;;AAwBA;EACE,aAAA;EACA,2BAAA;EACA,eAAA;AArBF;AAsBE;EACE,kBAAA;EACA,iBAAA;EACA,WAAA;AApBJ;;AAwBA;EACE,iBAAA;AArBF","sourcesContent":[".ppfaDialog {\n  width: 85rem;\n\n  .file-list-data-row {\n    &:nth-child(1) {\n      max-width: 200px;\n    }\n  }\n\n  // height: 423px;\n  .p-dialog-header {\n    padding: 10px 18px !important;\n  }\n\n  .p-dialog-header1 {\n    padding: 0 10px 9px !important;\n  }\n\n  .ppfaDialogBreadCrumb {\n    padding-bottom: 12px !important;\n  }\n\n  .p-fileupload-content {\n    top: 100% !important;\n  }\n\n  .p-fluid .p-fileupload .p-button {\n    padding: 0;\n  }\n\n  .p-fileupload {\n    padding: 0;\n  }\n\n  .p-fileupload {\n    .p-fileupload-row {\n      .upload-row {\n        padding: 0;\n        margin-top: 10px;\n        text-align: left;\n      }\n    }\n  }\n\n  .p-fileupload-content {\n    padding: 0 20px !important;\n  }\n}\n\n.ppfaDialogBorder {\n  border: 1px solid #acacac;\n  padding: 24px 24px 0 24px;\n  border-radius: 4px;\n}\n\n.confirmPPFA {\n  padding: 16px 0 1px 0 !important;\n  text-align: right;\n  display: flex;\n\n  justify-content: space-between;\n\n  ul {\n    list-style: none;\n\n    text-align: left;\n\n    padding: 0 0 0 5px;\n  }\n  .p-button {\n    margin: 0 !important;\n  }\n}\n\n.confirmPPFA > button {\n  background-color: #003da5 !important;\n  width: 93px;\n  height: 40px;\n  color: #fff !important;\n  font-size: 12px;\n  border-radius: 20px;\n  padding: 16px 24px;\n}\n\n.ppfaDialogTextColor {\n  color: #ff0000;\n  text-align: center;\n}\n\n.radioLabel {\n  margin-left: 8px !important;\n}\n\n.cppfa-radio-buttons {\n  display: flex;\n}\n\n.p-fileupload-content {\n  padding: 0 1rem !important;\n}\n\n.highRiskData {\n  border: 0.5px solid #acacac;\n  min-width: 200px;\n  // height: 114.5px;\n  border-radius: 8px;\n  padding: 0;\n  margin: 10.5px;\n}\n\n.highRiskDataPaddingBottom {\n  padding-bottom: 24px;\n}\n\n.highRiskDataColor {\n  color: #595959;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 12.19px;\n  padding: 10px;\n  width: 18rem;\n  margin-bottom: 10px;\n  div {\n    font-size: 10px;\n  }\n}\n\n.highRiskButtons {\n  display: flex;\n  justify-content: right;\n  padding-top: 2px;\n  margin-bottom: 10px;\n  .btn.btn-secondary {\n    color: #595959 !important;\n  }\n  .highRiskButton {\n    // color: #595959 !important;\n    width: 33px;\n    height: 20px;\n    border: 0.5px solid #acacac !important;\n    border-radius: 4px;\n    margin-right: 10px;\n    font-size: 10px;\n    line-height: 12px;\n    &.btn:disabled {\n      color: #ffffff !important;\n      width: 33px;\n      height: 20px;\n      border: 0.5px solid #acacac !important;\n      border-radius: 4px;\n      margin-right: 10px;\n      font-size: 10px;\n      line-height: 12px;\n    }\n  }\n}\n\n.yesOrNoButtonsColor.btn:disabled {\n  background-color: #003da5 !important;\n}\n\n.highRiskErrorBorderColor {\n  border-color: #ff0000 !important;\n}\n\n.highRiskError {\n  color: #ff0000;\n  font-size: 8px;\n  line-height: 10px;\n  margin: 4px 0 10px 0;\n}\n\n.yesOrNoButtonsColor {\n  background-color: #003da5;\n  color: #ffffff !important;\n}\n\n.yesOrNoButtonsColor:hover {\n  background-color: #003da5 !important;\n  color: black !important;\n}\n\n.uploadIcon {\n  background-color: #fff;\n}\n\n.fileSupportedData {\n  font-size: 8px;\n  line-height: 9.75px;\n  color: #5b5959;\n}\n.uploadImage {\n  cursor: pointer;\n  // width: 75%;\n  width: 100%;\n  text-align: center;\n  margin-top: 10px;\n}\n\n.ppfaDialogLoading {\n  padding-top: 100px;\n}\n\n.cpp-fa-button {\n  display: flex;\n  flex-direction: row-reverse;\n  margin: 0px 8px;\n  button {\n    border-radius: 4px;\n    padding: 4px 10px;\n    margin: 3px;\n  }\n}\n\n.select-one{\n  padding-top: 1rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
